export default {
    links: [
        {
            icon: 'article',
            title: 'Production',
            description: 'notabene-1.0',
            to: 'articles-drafts',
            group: 'Articles',
            importance: 1,
            permissions: ['create content'],
            roles: [
                'Publishing'
            ]
        },
        {
            icon: 'cloud_upload',
            title: 'Articles',
            description: 'Published articles',
            to: 'articles',
            group: 'Articles',
            importance: 2,
            permissions: ['create content'],
            roles: [
                'Publishing'
            ]
        },
        {
            icon: 'comment',
            title: 'Comments',
            description: 'Manage comments',
            to: 'comments',
            group: 'Articles',
            importance: 4,
            permissions: ['manage comments'],
            roles: [
                'Comments moderator'
            ]
        },
        {
            icon: 'account_circle',
            title: 'Contributors',
            description: 'Manage companies and authors',
            to: 'contributors',
            group: 'Editorial',
            importance: 7,
            permissions: ['read contributors'],
            roles: [
                'Editorial'
            ]
        },
        {
            icon: 'business',
            title: 'Clients',
            description: 'Coverage and office reports',
            to: 'clients',
            group: 'CRM',
            importance: 2,
            permissions: ['read agreements'],
            roles: [
                'crm', 'sales'
            ]
        },
        {
            icon: 'book',
            title: 'Article analytics',
            description: 'Find analytics for an article',
            to: 'analytics-articles',
            group: 'Analytics',
            permissions: ['read agreements']
        },
        {
            icon: 'spellcheck',
            title: 'Intellitext estimates',
            description: 'Intellitext analytics',
            to: 'analytics-intellitext',
            group: 'Analytics',
            permissions: ['read agreements']
        },
        {
            icon: 'file_download',
            title: 'Downloads',
            description: 'Download related analytics',
            to: 'analytics-downloads',
            group: 'Analytics',
            permissions: ['read agreements'],
            roles: [
                'crm', 'sales'
            ]
        },
        // {
        //     icon: 'event_seat',
        //     title: 'Microsite Registrations',
        //     description: 'Registrations for microsites',
        //     to: 'registrations',
        //     permissions: ['read agreements'],
        //     roles: [
        //         'crm', 'sales'
        //     ]
        // },
        {
            icon: 'flip_to_front',
            title: 'Frontpage',
            description: 'What does today look like?',
            to: 'frontpage',
            group: 'Articles',
            importance: 3,
            permissions: ['read layouts'],
            roles: [
                'editorial'
            ]
        },
        {
            icon: 'show_chart',
            title: 'Surveys',
            description: 'Survey responses and graphs',
            to: 'surveys',
            group: 'CRM',
            importance: 4,
            permissions: ['read surveys'],
            roles: [
                'survey'
            ]
        },
        {
            icon: 'stars',
            title: 'Categories',
            description: 'Categories - overview and sponsors',
            to: 'categories',
            group: 'Editorial',
            importance: 8,
            permissions: ['read modules'],
            roles: [
                'editorial'
            ]
        },
        {
            icon: 'trending_up',
            title: 'Daily report',
            description: 'Daily report',
            to: 'analytics-daily',
            group: 'Analytics',
            permissions: ['analytics content'],
            roles: [
                'editorial'
            ]
        },
        {
            icon: 'view_module',
            title: 'Spotlight',
            description: 'Spotlight module',
            to: 'spotlight',
            group: 'Editorial',
            importance: 5,
            permissions: ['read modules'],
            roles: [
                'Editorial'
            ]
        },
        {
            icon: 'view_module',
            title: 'Cartoons',
            description: 'Manage cartoons',
            to: 'cartoons',
            group: 'Editorial',
            importance: 6,
            permissions: ['read modules'],
            roles: [
                'Editorial'
            ]
        },
        {
            icon: 'event',
            title: 'Events',
            description: 'Events modules, news and matchmaking',
            to: 'events',
            group: 'Events & Portals',
            importance: 1,
            permissions: ['read modules', 'manage events'],
            roles: [
                'Editorial'
            ]
        },
        {
            icon: 'emoji_events',
            title: 'Nominations',
            description: 'Manage nominations',
            to: 'nominations',
            group: 'Events & Portals',
            permissions: ['read nominations', 'update nominations'],
            roles: [
                'Nominations'
            ]
        },
        {
            icon: 'view_module',
            title: 'Modules',
            description: 'Create, read and update modules',
            to: 'modules',
            group: 'Editorial',
            importance: 3,
            permissions: ['read modules', 'manage events'],
            roles: ['Editorial'],
            /*publication: 'africa'*/
        },
        {
            icon: 'email',
            title: 'Newsletters',
            description: 'Manage layout and articles for newsletters',
            to: 'layouts',
            group: 'Editorial',
            importance: 1,
            permissions: ['read layouts', 'ordering layouts'],
            roles: [
                'Editorial'
            ]
        },
        {
            icon: 'dns',
            title: 'Domain Stats',
            description: 'Domain Stats',
            to: 'domainstats',
            group: 'Analytics',
            permissions: ['read domainstats'],
            roles: [
                'Editorial'
            ]
        },
        {
            icon: 'account_balance',
            title: 'ClientTracker',
            description: 'Manage agreements',
            to: 'agreements',
            group: 'CRM',
            importance: 1,
            permissions: ['update agreements'],
            roles: [
                'crm', 'sales'
            ]
        },
        // {
        //     icon: 'add_business',
        //     title: 'Agreements',
        //     description: 'Create new client agreement',
        //     to: 'agreements-inspire-create',
        //     permissions: ['update agreements'],
        //     roles: [
        //         'crm', 'sales'
        //     ]
        // },
        {
            icon: 'supervised_user_circle',
            title: 'User & ACL management',
            description: 'Manage users, roles and permissions',
            to: 'user-management',
            group: 'Settings',
            permissions: ['manage acl', 'manage consent'],
            roles: ['Administrator']
        },
        {
            icon: 'menu',
            title: 'Menu',
            description: 'Manage navigation drawer',
            to: 'menu',
            group: 'Settings',
            permissions: ['manage menu'],
            roles: ['Menu Administrator']
        },
        {
            icon: 'style',
            title: 'Office',
            description: 'Create and update office',
            to: 'office',
            group: 'CRM',
            importance: 3,
            permissions: ['create office'],
            roles: ['Administrator']
        },
        {
            icon: 'forward',
            title: 'ICT Insight',
            description: 'ICT Insight articles',
            to: 'ict-insight',
            group: 'Editorial',
            importance: 9,
            permissions: ['read ictinsight'],
            roles: ['Administrator']
        },
        {
            icon: 'video_library',
            title: 'Videos',
            description: 'Video content',
            to: 'videos',
            group: 'Editorial',
            importance: 2,
            permissions: ['manage videos'],
            roles: ['Videographer']
        },
        {
            icon: 'dynamic_form',
            title: 'Forms',
            description: 'Registration forms',
            to: 'forms',
            group: 'Events & Portals',
            importance: 2,
            permissions: ['read registrations'],
            roles: [
                'Form administrator'
            ]
        },
        {
            icon: 'people',
            title: 'Events portals',
            description: 'Create and update events portals.',
            to: 'events-portals',
            group: 'Events & Portals',
            importance: 3,
            permissions: ['create events portals'],
            roles: [
                'Online designer'
            ]
        },
        {
            icon: 'people',
            title: 'Control Room',
            description: 'Control Room for live events.',
            to: 'roomControl',
            group: 'Events & Portals',
            importance: 6,
            permissions: ['manage event platform'],
            roles: [
                'Event Platform Administrator'
            ]
        },
        {
            icon: 'people',
            title: 'Books',
            description: 'Books Management',
            to: 'books',
            group: 'Editorial',
            importance: 4,
            permissions: ['create events portals'],
            roles: [
                'Administrator'
            ]
        },
        {
            icon: 'people',
            title: 'Tables',
            description: 'Tables Management',
            to: 'tables',
            group: 'Events & Portals',
            importance: 5,
            permissions: ['read registrations'],
            roles: [
                'Form administrator'
            ]
        },
        {
            icon: 'table_restaurant',
            title: 'Floor plan',
            description: 'Seat guests on a floor plan',
            to: 'tables-floor-plan',
            group: 'Events & Portals',
            importance: 5,
            permissions: ['read registrations'],
            roles: [
                'Form administrator'
            ]
        },
        // {
        //     icon: 'people',
        //     title: 'QR Code',
        //     description: 'QR Code',
        //     to: 'qrcode',
        //     permissions: ['read qrcode'],
        //     roles: [
        //         'Administrator'
        //     ]
        // },
        // {
        //     icon: 'people',
        //     title: 'Inspire',
        //     description: 'Inspire',
        //     to: 'inspire',
        //     permissions: ['read modules', 'manage events'],
        //     roles: [
        //         'Administrator'
        //     ]
        // },
        {
            icon: 'people',
            title: 'Search',
            description: 'Search',
            to: 'search',
            group: 'Settings',
            permissions: ['read qrcode'],
            roles: [
                'Administrator'
            ]
        },
        {
            icon: 'people',
            title: 'Subscribers',
            description: 'Subscriber management',
            to: 'subscriber',
            group: 'Settings',
            permissions: ['manage subscribers'],
            publication: 'brainstorm',
            roles: [
                'Circulation'
            ]
        },
        // {
        //     icon: 'people',
        //     title: 'CIO Table',
        //     description: 'table',
        //     to: 'cio-table',
        //     permissions: ['read qrcode'],
        //     roles: [
        //         'Administrator'
        //     ]
        // },
        // {
        //     icon: 'people',
        //     title: 'Dilbert',
        //     description: 'Create and update dilbert portals.',
        //     to: 'dilbert',
        //     permissions: ['create events portals'],
        //     roles: [
        //         'Online designer'
        //     ]
        // },
        {
            icon: 'calendar_month',
            title: 'Calendar',
            description: 'Create Calendar .ics file',
            to: 'calendar',
            group: 'Events & Portals',
            importance: 4,
            permissions: ['read modules', 'manage events'],
            roles: [
                'Editorial'
            ]
        },
        {
            icon: 'photo_camera',
            title: 'Featured Artist',
            description: 'Manage featured artists for the Brainstorm calendar',
            to: 'featured-artist',
            group: 'Events & Portals',
            importance: 5,
            publication: 'brainstorm',
            permissions: ['read modules', 'manage events'],
            roles: [
                'Editorial'
            ]
        },
        {
            icon: 'business',
            title: 'Sponsored Words',
            description: 'Sponsored Words',
            to: 'sponsored-words',
            group: 'CRM',
            importance: 5,
            permissions: ['manage advertising'],
            roles: [
                'crm'
            ]
        },
        {
            icon: 'business',
            title: 'Section Balancing',
            description: 'Section Balancing',
            to: 'section-balancing',
            group: 'Analytics',
            permissions: ['manage advertising'],
            roles: [
                'crm'
            ]
        },
        {
            icon: 'style',
            title: 'Vertex AI',
            description: 'Manage Articles for AI search',
            to: 'vertex-ai',
            group: 'Settings',
            permissions: ['create office'],
            roles: ['Administrator']
        },
        {
            icon: 'call_split',
            title: 'Directory Leads',
            description: 'Manage Directory Leads',
            to: 'directories-leads',
            group: 'Settings',
            publication: 'brainstorm',
            permissions: ['manage directory'],
            roles: ['Directory']
        },
    ]
}
